__turbopack_context__.v({
  "arrowBounce": "ParagraphProductVariantsSelector-module__RU891a__arrowBounce",
  "arrowDown": "ParagraphProductVariantsSelector-module__RU891a__arrowDown",
  "body": "ParagraphProductVariantsSelector-module__RU891a__body",
  "card": "ParagraphProductVariantsSelector-module__RU891a__card",
  "cardActive": "ParagraphProductVariantsSelector-module__RU891a__cardActive",
  "cardName": "ParagraphProductVariantsSelector-module__RU891a__cardName",
  "cardSubtitle": "ParagraphProductVariantsSelector-module__RU891a__cardSubtitle",
  "cards": "ParagraphProductVariantsSelector-module__RU891a__cards",
  "content": "ParagraphProductVariantsSelector-module__RU891a__content",
  "contentTitle": "ParagraphProductVariantsSelector-module__RU891a__contentTitle",
  "ctaBtn": "ParagraphProductVariantsSelector-module__RU891a__ctaBtn",
  "desc": "ParagraphProductVariantsSelector-module__RU891a__desc" + " " + __turbopack_context__.i("[project]/components/cms/Paragraphs/layouts/sectionHeader.module.css [app-client] (css module)")["lead"],
  "descBody": "ParagraphProductVariantsSelector-module__RU891a__descBody",
  "descLead": "ParagraphProductVariantsSelector-module__RU891a__descLead",
  "eyebrow": "ParagraphProductVariantsSelector-module__RU891a__eyebrow",
  "feature": "ParagraphProductVariantsSelector-module__RU891a__feature",
  "featureCheck": "ParagraphProductVariantsSelector-module__RU891a__featureCheck",
  "features": "ParagraphProductVariantsSelector-module__RU891a__features",
  "handIcon": "ParagraphProductVariantsSelector-module__RU891a__handIcon",
  "handPulse": "ParagraphProductVariantsSelector-module__RU891a__handPulse",
  "hintPill": "ParagraphProductVariantsSelector-module__RU891a__hintPill",
  "inner": "ParagraphProductVariantsSelector-module__RU891a__inner",
  "mediaPlaceholder": "ParagraphProductVariantsSelector-module__RU891a__mediaPlaceholder",
  "mediaWrap": "ParagraphProductVariantsSelector-module__RU891a__mediaWrap",
  "placeholder": "ParagraphProductVariantsSelector-module__RU891a__placeholder",
  "placeholderDesc": "ParagraphProductVariantsSelector-module__RU891a__placeholderDesc",
  "placeholderIcon": "ParagraphProductVariantsSelector-module__RU891a__placeholderIcon",
  "placeholderTitle": "ParagraphProductVariantsSelector-module__RU891a__placeholderTitle",
  "section": "ParagraphProductVariantsSelector-module__RU891a__section",
  "title": "ParagraphProductVariantsSelector-module__RU891a__title" + " " + __turbopack_context__.i("[project]/components/cms/Paragraphs/layouts/sectionHeader.module.css [app-client] (css module)")["title"],
});
